import callApi from '../../util/apiCaller';

export function update(_id, body) {
  return callApi(`contact/${_id}`, 'POST', body);
}

export function findContacts(body, userType) {
  return callApi(`contact/search/${userType}`, 'POST', body);
}
